// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1eqWE","label":"Completed_label__2A0nB"};